import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

let TopMv = new Swiper('.topMv__slider, .topMv__sliderSP', {
  speed: 2000,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
})

document.addEventListener('DOMContentLoaded', function (e) {
  const tabs = document.querySelectorAll('[data-tab-target]')
  const tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('active')
      })
      tabs.forEach((tab) => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })

  let elmMV = document.getElementsByClassName('topMv')
  let elmHead = document.querySelector('.header')

  document.addEventListener('scroll', function (e) {
    let currentScroll = window.scrollY

    if (document.querySelector('.topMv')) {
      if (currentScroll >= elmMV[0].offsetHeight) {
        elmHead.classList.add('fixed')
      } else {
        elmHead.classList.remove('fixed')
      }
    }
  })
})
